import { render } from "./VDateFieldComponent.vue?vue&type=template&id=4cba4aa0"
import script from "./VDateFieldComponent.vue?vue&type=script&lang=js"
export * from "./VDateFieldComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__